import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Label } from "components/ui/label";
import iconRoulette from "@/assets/svg/roulette.svg";
import iconSoccer from "@/assets/svg/soccer.svg";
import { STATUS_LABELS } from '../../utils/status';
import { useCampaignRouletteFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { CampaignType } from "../../../../../@types/campaign-roulette";
import PeriodRangeFilter from "@/components/PeriodRangeFilter";

export default function SelectFilters() {
  const { updateFilter } = useCampaignRouletteFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const handlePeriodChange = (start: string | undefined, end: string | undefined) => {
    updateFilter({ key: "periodStart", value: start });
    updateFilter({ key: "periodEnd", value: end });
    updateFilter({ key: "meta", value: { page: 1, perPage: filters.meta?.perPage || 10 } });
  };

  return (
    <div className="grid w-full gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="campaign-type-filter" className="text-sm">Tipo</Label>
        <Select
          value={filters.campaignType ?? "all"}
          onValueChange={(value) => {
            updateFilter({
              key: "campaignType",
              value: value === "all" ? undefined : (value as CampaignType),
            });
          }}
        >
          <SelectTrigger className="h-8 w-full" id="campaign-type-filter">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os tipos</SelectItem>
            <SelectItem value={CampaignType.ROULETTE}>
              <span className="flex items-center gap-2">
                <img src={iconRoulette} alt="" className="h-4 w-4" />
                Roleta
              </span>
            </SelectItem>
            <SelectItem value={CampaignType.WORLD_CUP}>
              <span className="flex items-center gap-2">
                <img src={iconSoccer} alt="" className="h-4 w-4" />
                Copa do Mundo
              </span>
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="status-filter" className="text-sm">Status</Label>
        <Select
          value={filters.status || "all"}
          onValueChange={(value) => {
            updateFilter({ key: "status", value: value === "all" ? "" : value });
          }}
        >
          <SelectTrigger className="h-8 w-full" id="status-filter">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os status</SelectItem>
            {Object.entries(STATUS_LABELS).map(([status, label]) => (
              <SelectItem key={status} value={status}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="period-filter" className="text-sm">Período</Label>
        <PeriodRangeFilter
          start={filters.periodStart}
          end={filters.periodEnd}
          onChange={handlePeriodChange}
          inline
          buttonClassName="w-full h-8 justify-start font-normal"
          allowFutureDates
        />
      </div>
    </div>
  );
}
